import Paystack from '@paystack/inline-js';
import eventBus from '../events/event-bus';

class PaystackPaymentService {

    private paymentPopup = new Paystack();
    private key: string = "";
    private email: string = "";
    private amount: number = 0;
    private reference: string = "";
    private currency: string = "";
    private firstName: string = "";
    private lastName: string = "";
    private phone: string = "";

    builder(): this {
        return this;
    }

    addReference(reference: string): this {
        this.reference = reference;
        return this
    }

    addApiKey(key: string): this {
        this.key = key;
        return this;
    }

    addEmail(email: string): this {
        this.email = email;
        return this;
    }

    addAmount(amount: number): this {
        this.amount = amount;
        return this;
    }

    addCurrency(currency: string): this {
        this.currency = currency;
        return this;
    }
    
    addFirstName(firstName: string): this {
        this.firstName = firstName;
        return this;
    }
    
    addLastName(lastName: string): this {
        this.lastName = lastName;
        return this;
    }
    
    addPhone(phone: string): this {
        this.phone = phone;
        return this;
    }

    build() {
        try {
            return this.paymentPopup.checkout({
                key: this.key,
                email: this.email,
                amount: this.amount,
                reference: this.reference,
                currency: this.currency,
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                onSuccess: (transaction) => {
                    eventBus.dispatchEvent(new CustomEvent('payment:onSucces', {detail: transaction}))
                },
                onLoad: (response) => {
                    eventBus.dispatchEvent(new CustomEvent('payment:onLoad', {detail: response}));
                },
                onCancel: () => {
                    eventBus.dispatchEvent(new CustomEvent('payment:onCancel', {detail: {isCancelled: true}}));
                },
                onError: (error) => {
                    eventBus.dispatchEvent(new CustomEvent('payment:onError', {detail: {error: error.message}}));
                }
            });
        } catch (error) {
          console.log("error thrown = ", error);
        }
    }
}

export default PaystackPaymentService;